// Footer component

import { Box, Container, Flex, HStack, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';

/**
 * Footer component with copyright and version
 */
export function Footer() {
  const version = import.meta.env.VITE_APP_VERSION || '1.0.0';

  return (
    <Box py={8} borderTop="1px" borderColor="border-default" bg="bg-surface">
      <Container maxW="7xl">
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align="center"
          gap={4}
        >
          <HStack spacing={2}>
            <Text fontSize="sm" color="text-secondary">
              © {dayjs().format("YYYY")} TaskEye. All rights reserved.
            </Text>
          </HStack>
          <HStack spacing={6} fontSize="sm">
            <Text>Version {version}</Text>
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
}
